module.exports = __webpack_public_path__ + "img/delete.52ccae69.svg";